"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const dependency_graph_1 = require("dependency-graph");
const v1_1 = tslib_1.__importDefault(require("uuid/v1"));
const covariate_1 = require("../engine/data-field/covariate/covariate");
const derived_field_1 = require("../engine/data-field/derived-field/derived-field");
class CovariateDepGraph extends dependency_graph_1.DepGraph {
    constructor(covariate) {
        super();
        this.covariateUuid = v1_1.default();
        this.addNode(this.covariateUuid, {
            field: covariate,
        });
        this.addNodesForCovariate(covariate, this.covariateUuid);
    }
    addNodesForCovariate(covariate, nodeUuid) {
        if (covariate.derivedField) {
            this.addNodesForDerivedField(covariate.derivedField, nodeUuid);
        }
        else if (covariate.customFunction) {
            const newNodeUuid = this.addNewField(covariate.customFunction.firstVariableCovariate);
            this.addDependency(nodeUuid, newNodeUuid);
            this.addNodesForCovariate(covariate.customFunction.firstVariableCovariate, newNodeUuid);
        }
    }
    addNodesForDerivedField(derivedField, nodeUuid) {
        derivedField.derivedFrom.forEach(derivedFromField => {
            const newNodeUuid = this.addNewField(derivedFromField);
            this.addDependency(nodeUuid, newNodeUuid);
            if (derivedFromField instanceof derived_field_1.DerivedField) {
                this.addNodesForDerivedField(derivedFromField, newNodeUuid);
            }
            else if (derivedFromField instanceof covariate_1.Covariate) {
                this.addNodesForCovariate(derivedFromField, newNodeUuid);
            }
        });
    }
    addNewField(field) {
        const fieldNodeUuid = v1_1.default();
        this.addNode(fieldNodeUuid, {
            field,
        });
        return fieldNodeUuid;
    }
}
exports.CovariateDepGraph = CovariateDepGraph;
//# sourceMappingURL=covariate-dep-graph.js.map